/* eslint-disable camelcase */

export default {
  methods: {
    caseDeviceHasStock(caseDeviceId) {
      return this.productStock.case_devices[caseDeviceId]
    },
    isInStock(option) {
      let caseDevice
      if (option?.case_types?.length) {
        const allAvailable = option.case_types.filter((ct) => {
          const cd = ct?.devices?.find((d) => d.device_id === this.deviceId)
          return this.caseDeviceHasStock(cd.case_device_id)
        })

        return allAvailable.length
      } else {
        caseDevice = this.getOptionDevice(option)
      }

      return this.caseDeviceHasStock(caseDevice.case_device_id)
    },
  },
}
